<template>
    <b-modal
        id="access-control-role-assign-modal"
        v-model="visibleModel"
        size="md"
        centered
        hide-footer
        body-class="p-0"
        header-class="role-assign-modal-header"
    >
        <template #modal-header="{ close }">
            <div class="elite-header-inner">
                <div class="role-assign-header-text">
                    <span class="elite-title-inner">사용자 역할 관리</span>
                    <span v-if="user" class="role-assign-user-inline">
                        {{ user.userName }} <span class="role-assign-user-id">({{ user.loginId }})</span>
                    </span>
                </div>
                <b-button variant="link" class="elite-header-close p-0 ml-auto" aria-label="닫기" @click="close()">
                    <i class="fas fa-times"></i>
                </b-button>
            </div>
        </template>

        <div class="role-assign-wrap">
            <main class="role-assign-main custom-scrollbar">
                <section class="role-assign-section">
                    <div class="role-assign-body" v-if="roles && roles.length">
                        <div
                            v-for="role in roles"
                            :key="role.roleIdx"
                            class="role-assign-item"
                            @click="
                                toggleUserRole(role.roleIdx, { target: { checked: !userHasRole(user, role.roleIdx) } })
                            "
                        >
                            <div class="role-assign-item-main">
                                <label class="role-assign-checkbox">
                                    <input
                                        type="checkbox"
                                        :checked="userHasRole(user, role.roleIdx)"
                                        @change.stop="toggleUserRole(role.roleIdx, $event)"
                                    />
                                    <span class="role-assign-name">{{ role.roleName }}</span>
                                </label>
                                <span class="role-assign-code" v-if="role.roleCode">#{{ role.roleCode }}</span>
                            </div>
                            <div v-if="role.remarks" class="role-assign-remarks">
                                {{ role.remarks }}
                            </div>
                        </div>
                    </div>
                    <div v-else class="role-assign-empty">등록된 역할이 없습니다.</div>
                </section>
            </main>

            <footer class="role-assign-footer">
                <CarbonButton variant="secondary" @click="$emit('input', false)">닫기</CarbonButton>
            </footer>
        </div>
    </b-modal>
</template>

<script>
import CarbonButton from "../../common/CarbonButton.vue";

export default {
    name: "RoleAssignModal",
    components: { CarbonButton },
    props: {
        value: { type: Boolean, default: false },
        user: { type: Object, default: null },
        roles: { type: Array, default: () => [] },
    },
    computed: {
        visibleModel: {
            get() {
                return this.value;
            },
            set(v) {
                this.$emit("input", v);
            },
        },
    },
    methods: {
        userHasRole(user, roleIdx) {
            return user?.roles?.some((role) => role.roleIdx === roleIdx);
        },
        toggleUserRole(roleIdx, event) {
            this.$emit("toggle-role", { roleIdx, checked: event.target.checked });
        },
    },
};
</script>

<style scoped>
.role-assign-modal-header {
    padding: 0;
    border-bottom: none;
}

.role-assign-wrap {
    display: flex;
    flex-direction: column;
    max-height: 80vh;
    min-height: 0;
    background: #fff;
}
.elite-header-inner {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
}

.role-assign-header-text {
    display: flex;
    align-items: baseline;
    gap: 8px;
    flex: 1 1 auto;
}

.elite-title-inner {
    font-size: 15px;
    font-weight: 700;
    color: #334155;
}

.role-assign-user-inline {
    font-size: 12px;
    color: #64748b;
}

.role-assign-user-id {
    color: #94a3b8;
}

.elite-header-close {
    color: #9ca3af;
}

.elite-header-close:hover {
    color: #4b5563;
}

.role-assign-main.custom-scrollbar {
    flex: 1 1 auto;
    overflow-y: auto;
    padding: 12px 18px 6px;
}

.role-assign-section {
    margin: 0;
}

.role-assign-section-head {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 10px;
}

.role-assign-section-bar {
    width: 3px;
    height: 16px;
    background: #10b981;
    border-radius: 9999px;
}

.role-assign-section-title {
    font-size: 11px;
    font-weight: 700;
    color: #94a3b8;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    margin: 0;
}

.role-assign-body {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.role-assign-item {
    border-radius: 10px;
    border: 1px solid #e5e7eb;
    padding: 12px 16px;
    background: #f9fafb;
    cursor: pointer;
    transition:
        background 0.15s ease,
        border-color 0.15s ease;
}

.role-assign-item:hover {
    background: #eff6ff;
    border-color: #bfdbfe;
}

.role-assign-item-main {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.role-assign-checkbox {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    color: #111827;
    margin-bottom: 0 !important;
}

.role-assign-checkbox input[type="checkbox"] {
    width: 16px;
    height: 16px;
}

.role-assign-name {
    font-weight: 500;
}

.role-assign-code {
    font-size: 11px;
    color: #9ca3af;
}

.role-assign-remarks {
    margin-top: 4px;
    font-size: 11px;
    color: #6b7280;
}

.role-assign-empty {
    padding: 16px 8px;
    font-size: 12px;
    color: #9ca3af;
    text-align: center;
}

.role-assign-footer {
    display: flex;
    justify-content: flex-end;
    padding: 10px 18px 14px;
    border-top: 1px solid #e5e7eb;
}
</style>
